import React from 'react';
import NotificationsIndexPage from '../notifications_index_page/NotificationsIndexPage';
import {
	BUYER_NOTIFICATION_APPROVALS_TYPES_MAP,
	UNREAD_NOTIFICATION_TYPES,
} from '../../utils/NotificationUtils';
import { Radio } from 'antd';
import { isNil } from 'lodash';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { connect } from 'react-redux';

function NotificationsApprovals({
	userType,
	fetchUserNotificationsCountForBuyer,
	fetchUserNotificationsCountForSupplier,
}) {
	const fetchUserNotificationsCount =
		userType === ROLE_TYPES.BUYER
			? fetchUserNotificationsCountForBuyer
			: fetchUserNotificationsCountForSupplier;
	return (
		<NotificationsIndexPage
			key="NotificationsApprovals"
			onNotificationClick={() => {
				fetchUserNotificationsCount(UNREAD_NOTIFICATION_TYPES, 'TASKS_NOTIFICATIONS');
			}}
			preAppliedFilters={{
				isActionRequired: true,
				pendingApproval: true,
			}}
			notificationTypes={BUYER_NOTIFICATION_APPROVALS_TYPES_MAP.map((filter) => {
				if (filter.children && filter.children.length > 0) {
					return filter.children.map((child) => child.key);
				}
				return filter.key;
			}).flat()}
			showUnreadFilter={false}
			showFilters={false}
			typeFilters={BUYER_NOTIFICATION_APPROVALS_TYPES_MAP}
			extraFilters={({ updateFilters, targetCollection, activeFilters }) => {
				const items = [
					{
						key: 'pendingOnMe',
						label: 'Waiting on me',
						value: { isActionRequired: true, pendingApproval: true },
					},
					{
						key: 'pendingOnTeam',
						label: 'Waiting on Others',
						value: { pendingApproval: true, isActionRequired: false },
					},
					{
						key: 'approvalCompleted',
						label: 'Approved/Declined',
						value: { isActionRequired: false, pendingApproval: false },
					},
				];
				const selectedVal = isNil(activeFilters)
					? 'approvalCompleted'
					: activeFilters.isActionRequired === false && activeFilters.pendingApproval === false
					? 'approvalCompleted'
					: activeFilters.isActionRequired === false && activeFilters.pendingApproval
					? 'pendingOnTeam'
					: 'pendingOnMe';

				return (
					<Radio.Group value={selectedVal}>
						{items.map((item) => (
							<Radio.Button
								style={{ flexWrap: 'nowrap', height: 40, lineHeight: '40px' }}
								key={item.key}
								onClick={() => updateFilters(item.value, targetCollection)}
								value={item.key}
							>
								{item.label}
							</Radio.Button>
						))}
					</Radio.Group>
				);
			}}
		/>
	);
}

const mapStateToProps = (state, ownProps) => ({
	userType: state.session.userType,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsApprovals);
